<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">Telnet / SSH</div>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" @click="clickPreStep" :disabled="!isLoaded">전단계</el-button>
        <el-button type="primary" @click="clickNextStep" :disabled="!isLoaded">다음단계</el-button>
      </div>
    </el-row>
    <el-table-wrapper :data="connectionTableData" :columns="connectionTableColumn" :column-default="columnDefault" ref="connectionTable" highlight-current-row :pagination="false" :show-search-tool="false" :show-custom-header="true"
      @selection-change="changeCheckedRow" @row-dblclick="dblclickRow" style="width:100%;" >
    </el-table-wrapper>
    <w-credential-info-popup ref="credentialInfoPopup" :selected-basic-info-form-data="selectedBasicInfoFormData" :selected-sub-form-data="selectedSubFormData" @close-popup="initSelectedInfo"></w-credential-info-popup>
  </div>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash';
import { columnDefault } from '@/constants/table';
import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';
import WCredentialInfoPopup from '../popup/CredentialInfoPopup';

export default {
  name: 'WConnectionSetting',
  components: {
    WCredentialInfoPopup,
  },
  props: {
    checkedConnectionRows: Array,
  },
  data() {
    return {
      isLoaded: false,
      checkedRows: [],
      connectionTableData: [],
      columnDefault,
      connectionTableColumn: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'credentialName',
          label: '이름',
        },
        {
          prop: 'credentialTypeId',
          label: '종류',
        },
        {
          prop: 'credentialDesc',
          label: '설명',
        },
      ],
      selectedBasicInfoFormData: null,
      selectedSubFormData: null,
      popupType: 'INFO',
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoaded = false;
      this.checkedRows = [];
      DeviceRegistrationNmsAPI.getModelingMethodList({ credentialMethodId: 'CONNECTION' }).then((response) => {
        this.connectionTableData = cloneDeep(response.data.data);
        this.isLoaded = true;
        this.$nextTick(() => {
          if (this.checkedConnectionRows.length > 0) {
            this.checkedConnectionRows.forEach((checkedObject) => {
              this.connectionTableData.forEach((tableObject) => {
                if (isEqual(checkedObject.credentialId, tableObject.credentialId)) {
                  this.$refs.connectionTable.$children[0].toggleRowSelection(tableObject, true);
                }
              });
            });
          }
        });
      });
    },
    dblclickRow(row) {
      DeviceRegistrationNmsAPI.getNmsCredentialValueList(row).then((response) => {
        this.selectedBasicInfoFormData = cloneDeep(row);
        this.selectedSubFormData = cloneDeep(response.data.data);
        this.selectedSubFormData.credentialTypeId = this.selectedBasicInfoFormData.credentialTypeId;
        this.$refs.credentialInfoPopup.$refs.slidingPopup.visible = true;
      });
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    clickNextStep() {
      this.$emit('click-next-step', this.checkedRows, 'checkedConnectionRows');
    },
    clickPreStep() {
      this.$emit('click-pre-step', this.checkedRows, 'checkedConnectionRows');
    },
    initSelectedInfo() {
      this.selectedBasicInfoFormData = null;
      this.selectedSubFormData = null;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/components/ConnectionSetting.vue